var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationBuildingAdministrative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 31h62v-.415L40 13.147 9 30.585V31zm63 2H8a1 1 0 01-1-1v-2a1 1 0 01.51-.871l32-18a.995.995 0 01.98 0l32 18A1 1 0 0173 30v2a1 1 0 01-1 1zM67 41H55v-5h2v3h8v-3h2v5M67 64h-2v-3h-8v3h-2v-5h12v5",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M57 60h2V41h-2zM63 60h2V41h-2zM53 41H41v-5h2v3h8v-3h2v5M53 64h-2v-3h-8v3h-2v-5h12v5",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M43 60h2V41h-2zM49 60h2V41h-2zM39 41H27v-5h2v3h8v-3h2v5M39 64h-2v-3h-8v3h-2v-5h12v5",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M29 60h2V41h-2zM35 60h2V41h-2zM25 41H13v-5h2v3h8v-3h2v5M25 64h-2v-3h-8v3h-2v-5h12v5",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M15 60h2V41h-2zM21 60h2V41h-2zM69 37H11v-5h2v3h54v-3h2v5",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 21c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M31 25h2v-2h-2zM8 69h64v-2H8zM47 25h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 67h54v-2H13v2zm-2 2h58v-6H11v6z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }))));
}

export default SvgIconIllustrationBuildingAdministrative;